export function fNumWithCommas(x?: number): string {
  if (x == null) return "0";
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function fCapitalizeFirst(x: any): string {
  if (x == null) return "";
  const words: string[] = x.split(" ");
  for (let i = 0; i < words.length; i += 1) {
    words[i] = words[i][0].toUpperCase() + words[i].slice(1);
  }
  return words.join(" ");
}

export function isMsisdnValid(x: string | number | boolean): boolean {
  if (typeof x === "boolean") return false;
  if (typeof x === "number") x = `${x}`;
  return x.length === 12;
}

export function formatArrayDate(dateArray: number[]) {
  const date = new Date(dateArray.map(v => v.toString()).join(" "));
  return date.toLocaleDateString();
}

export function cleanMsisdn(msisdn: string) {
  let x = msisdn
  if (x.startsWith("07")) {
    x = "254" + x.slice(1)
  } else if (x.startsWith("01")) {
    x = "254" + x.slice(1)
  } else if (x.startsWith("7")) {
    x = "254" + x
  } else if (x.startsWith("1")) {
    x = "254" + x
  }
  return x
}

export function validatePhone(phoneNumber: string) {
  // Regular expression for simple phone number format (US and Canada)
  const regex = /^(07|01|2547)\d{8}$|^(07|01|2547)\d{10}$/;
  return regex.test(phoneNumber);
}